import React, { createContext, useContext, useState } from "react";

type ExportFn = (() => void) | null;

const ExportContext = createContext<{
  setExportFn: (fn: ExportFn) => void;
  exportFn: ExportFn;
}>({
  setExportFn: () => {},
  exportFn: null,
});

export const useExport = () => useContext(ExportContext);

export const ExportProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [exportFn, setExportFn] = useState<ExportFn>(null);

  return (
    <ExportContext.Provider value={{ exportFn, setExportFn }}>
      {children}
    </ExportContext.Provider>
  );
};